import React from "react";
import InfoCard from "src/components/InfoCard";
import Layout from "src/components/Layout";

const RopeAccess: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"Rope Access Medical Fitness Certificate (IRATA)"}>
        <ul
          style={{
            color: "#000866",
            marginLeft: "20px",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <p>
            Rope access is a form of work positioning, initially developed from
            techniques used in climbing and caving, which applies practical rope
            work to allow workers to access difficult-to-reach locations without
            the use of scaffolding, cradles or an aerial work platform.
          </p>
        </ul>
      </InfoCard>
    </Layout>
  );
};

export default RopeAccess;
